(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminSurveyEditSettingsController', AdminSurveyEditSettingsController);

    function AdminSurveyEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const monthDates = [
            {value: 1, title: 1},
            {value: 2, title: 2},
            {value: 3, title: 3},
            {value: 4, title: 4},
            {value: 5, title: 5},
            {value: 6, title: 6},
            {value: 7, title: 7},
            {value: 8, title: 8},
            {value: 9, title: 9},
            {value: 10, title: 10},
            {value: 11, title: 11},
            {value: 12, title: 12},
            {value: 13, title: 13},
            {value: 14, title: 14},
            {value: 15, title: 15},
            {value: 16, title: 16},
            {value: 17, title: 17},
            {value: 18, title: 18},
            {value: 19, title: 19},
            {value: 20, title: 20},
            {value: 21, title: 21},
            {value: 22, title: 22},
            {value: 23, title: 23},
            {value: 24, title: 24},
            {value: 25, title: 25},
            {value: 26, title: 26},
            {value: 27, title: 27},
            {value: 28, title: 28},
        ];
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'fm_survey_submission_type',
                'fm_submit_kpi_by_date',
                'survey_timeout',
                'survey_automated_stats_enabled',
                'sp_auto_submit_kpi',
                'sp_submit_kpi_by_date'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            buildTabSettingFormTypes: () => ({
                'fm_survey_submission_type': {
                    type: 'radio',
                    radioLabelsAndValues: [
                        {value: 0, title: 'DAYS_AFTER_SP_SUBMISSION'},
                        {value: 1, title: 'DATE_OF_THE_MONTH'}
                    ]
                },
                'fm_submit_kpi_by_date': { type: 'select', notRequired: true, options: monthDates },
                'survey_timeout': { type: 'number', subLabel: 'KPI_TIMEOUT_SUB_LABEL', min: 0, notRequired: true, options: { invalid: false} },
                'survey_automated_stats_enabled': { type: 'checkbox', notRequired: false },
                'sp_auto_submit_kpi': { type: 'checkbox', notRequired: false },
                'sp_submit_kpi_by_date' : { type : 'select', options: monthDates }
            }),
            validateTabSettings: (vm) => {
                if (vm.settingsForm['sp_auto_submit_kpi'] && (vm.settingsForm['sp_submit_kpi_by_date'] === 0 || !vm.settingsForm['sp_submit_kpi_by_date'])) {
                    messenger.error('SELECT_SP_SUBMIT_DATE');
                    return false;
                }

                if (vm.settingsForm['fm_survey_submission_type'] === 1) {
                    vm.settingsForm['survey_timeout'] = parseInt(vm.settingsForm['survey_timeout']);
                    if (!vm.settingsForm['fm_submit_kpi_by_date'] || vm.settingsForm['fm_submit_kpi_by_date'].length === 0) {
                        messenger.error('SELECT_FM_SUBMIT_DATE');
                        return false;
                    }
                }

                return true;
            }
        });

        angular.extend(vm, base);
    }
})();
